import React from 'react';
import classnames from 'classnames';
import {TableCell} from '@material-ui/core';
import {OnClickEvent} from '@pluto/@types';
import {ListTableColumn} from './tableTypes';
import {cellAlignment, isExpandingCell} from './helpers';

export const customRender = (column: ListTableColumn, item: any) => {
    if (column.render) {
        return column.render(item);
    }
    
    if (item) {
        return item[column.dataKey];
    }
    
    return undefined;
};

export interface RowCellProps {
    item: any;
    column: ListTableColumn;
    rowHeight: number;
    onCellClick: OnClickEvent;
}

const RowCell = ({item, column, rowHeight, onCellClick}: RowCellProps) => {
    const alignment = cellAlignment(column.numeric);
    const classes = classnames('cell', {
        expandingCell: isExpandingCell(column.width),
    });
    const flexBasis = column.width;
    const styles = {
        flexBasis,
        height: rowHeight,
    };
    const itemRender = customRender(column, item);
    return (
        <TableCell
            component="div"
            variant="body"
            align={alignment}
            className={classes}
            style={styles}
            onClick={onCellClick}
        >
            {itemRender}
        </TableCell>
    );
};

export default RowCell;
